var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.313 3a4.684 4.684 0 0 0-3.329 1.383l-1.101 1.101A4.689 4.689 0 0 0 10.5 8.813c0 .594.114 1.174.328 1.71l1.219-1.218a3.214 3.214 0 0 1 .89-2.766l1.102-1.101a3.21 3.21 0 0 1 2.274-.938c.852 0 1.646.334 2.25.938a3.206 3.206 0 0 1 0 4.523l-1.102 1.101a3.21 3.21 0 0 1-2.273.938c-.168 0-.332-.018-.493-.047l-1.218 1.219a4.683 4.683 0 0 0 5.039-1.055l1.101-1.101A4.689 4.689 0 0 0 21 7.687a4.635 4.635 0 0 0-1.383-3.304A4.63 4.63 0 0 0 16.312 3ZM14.46 8.46l-6 6 1.078 1.08 6-6-1.078-1.08ZM8.812 10.5a4.684 4.684 0 0 0-3.328 1.383l-1.101 1.101A4.689 4.689 0 0 0 3 16.313c0 1.253.495 2.417 1.383 3.304A4.63 4.63 0 0 0 7.687 21a4.683 4.683 0 0 0 3.329-1.383l1.101-1.101a4.689 4.689 0 0 0 1.383-3.328c0-.595-.114-1.175-.328-1.711l-1.219 1.218a3.214 3.214 0 0 1-.89 2.766L9.96 18.563a3.21 3.21 0 0 1-2.274.937 3.156 3.156 0 0 1-2.25-.938 3.206 3.206 0 0 1 0-4.523l1.102-1.101A3.21 3.21 0 0 1 8.813 12c.166 0 .33.018.492.047l1.218-1.219a4.618 4.618 0 0 0-1.71-.328Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4698a90f9ac6fb4764b939c916e422ad.svg";
export { ForwardRef as ReactComponent };